import 'bootstrap/dist/css/bootstrap.min.css'
import './app.sass';
import './print.sass';

import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import Auth from 'services/Auth';

import SideNav from 'components/sideNav';
import PageHeader from 'components/pageHeader';
import Dashboard from 'components/Dashboard';
import Dialog from 'components/Dialog';
import UserActivityObserver from './components/UserActivityObserver';
import Login from 'screens/Login';
import Breeds from 'screens/Breeds';
import Users from 'screens/Users';
import Printers from 'screens/Printers';
import Experts from 'screens/Experts';
import ExpertCreate from 'screens/ExpertCreate';
import ExpertEdit from 'screens/ExpertEdit';
import ExpertBreeds from 'screens/ExpertBreeds';
import Shows from 'screens/Shows';
import ShowCreate from 'screens/ShowCreate';
import ShowSummary from 'screens/ShowSummary';
import ShowEdit from 'screens/ShowEdit';
import ShowDogs from 'screens/ShowDogs';
import ShowCertificates from 'screens/ShowCertificates';
import ShowDiplomas from 'screens/ShowDiplomas';
import ShowExperts from 'screens/ShowExperts';
import ShowExpertsByBreed from 'screens/ShowExpertsByBreed';
import ShowExpertsRings from 'screens/ShowExpertsRings';
import ShowExpertSortBreeds from 'screens/ShowExpertSortBreeds';
import ShowExpertRingReport from 'screens/ShowExpertRingReport';
import ShowFCIreport from 'screens/ShowFCIreport';
import ShowCRUFTSreport from 'screens/ShowCRUFTSreport';
import ShowContests from 'screens/ShowContests';
import Dogs from 'screens/Dogs';
import DogCreate from 'screens/DogCreate';
import DogEdit from 'screens/DogEdit';
import RegistrationRequests from 'screens/RegistrationRequests';
import RegistrationRequestProcess from 'screens/RegistrationRequestProcess';
import RegistrationRequestPrint from 'screens/RegistrationRequestPrint';
import ShowCatalogRecipients from 'screens/ShowCatalogRecipients';

class App extends Component {

  constructor(props) {
    super(props);
    const isAuthReady = Auth.isReady();
    this.state = {
      navBarOpen: false,
      error: !isAuthReady,
      ready: isAuthReady,
      authorized: Auth.isAuthenticated,
    }
    Auth.subscribe(this.authorizationUpdated);
  }

  authorizationUpdated = (authorized) => {
    this.setState({ authorized });
  }

  toggleOpenNavBar = () => {
    this.setState({ navBarOpen: !this.state.navBarOpen });
  }

  offOpenNavBar = () => {
    this.setState({ navBarOpen: false });
  }

  render() {
    return this.state.ready ? (
      <Router basename="new">
        <UserActivityObserver>
          <PageHeader toggleOpenNavBar={this.toggleOpenNavBar}/>
          <SideNav open={this.state.navBarOpen} offOpenNavBar={this.offOpenNavBar} />
          <main>
            { this.state.authorized && <Switch>
              <Route exact path="/" component={Dashboard} />
              <Route path="/breeds" component={Breeds} />
              <Route path="/users" component={Users} />
              <Route path="/printers" component={Printers} />

              <Route path="/experts/add" component={ExpertCreate} />
              <Route path="/experts/:id/breeds" component={ExpertBreeds} />
              <Route path="/experts/:id" component={ExpertEdit} />
              <Route path="/experts" component={Experts} />

              <Route path="/shows/add" component={ShowCreate} />
              <Route path="/shows/:id/dogs" component={ShowDogs} />
              <Route path="/shows/:id/fcireport" component={ShowFCIreport} />
              <Route path="/shows/:id/cruftsreport" component={ShowCRUFTSreport} />


              <Route path="/shows/:id/experts/:expertId/sort-breeds" component={ShowExpertSortBreeds} />
              <Route path="/shows/:id/experts/:expertId/ring-report" component={ShowExpertRingReport} />
              <Route path="/shows/:id/experts/by-breeds" component={ShowExpertsByBreed} />
              <Route path="/shows/:id/experts/rings" component={ShowExpertsRings} />

              <Route path="/shows/:id/diplomas" component={ShowDiplomas} />
              <Route path="/shows/:id/certificates" component={ShowCertificates} />
              <Route path="/shows/:id/catalog-recipients" component={ShowCatalogRecipients} />
              <Route path="/shows/:id/experts" component={ShowExperts} />
              <Route path="/shows/:id/contests" component={ShowContests} />
              <Route path="/shows/:id/edit" component={ShowEdit} />
              <Route path="/shows/:id" component={ShowSummary} />
              <Route path="/shows" component={Shows} />

              <Route path="/dogs/add" component={DogCreate} />
              <Route path="/dogs/:id" component={DogEdit} />
              <Route path="/dogs" component={Dogs} />

              <Route path="/registration-requests/:id/print" component={RegistrationRequestPrint} />
              <Route path="/registration-requests/:id" component={RegistrationRequestProcess} />
              <Route path="/registration-requests" component={RegistrationRequests} />

            </Switch>}
            {this.state.authorized ? null : <Dialog open="true" title="Войдите в систему"><Login /></Dialog>}
          </main>
          <footer></footer>
        </UserActivityObserver>
      </Router>
    ) : this.state.error ? (
      <div className="message">Критическая ошибка. Пожалуйста перезагрузите страницу. 
        При повторении обратитесь к разработчику.</div>
    ) : (
      <div className="loader">Loading...</div>
    );
  }
}

export default App;
